import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * MarkdownText — renderiza texto gerado pela IA (Gemini) que pode conter
 * markdown literal: "**negrito**", listas com "* item", cabeçalhos, etc.
 *
 * Sem este wrapper, ReportPrintable e ReportV2 mostram o texto cru — o leitor
 * vê os asteriscos e travessões em vez do negrito/lista renderizado. Bug B13.
 *
 * Segurança:
 *  - react-markdown@10 escapa/strippa HTML embutido por padrão (sem rehype-raw).
 *    Protege contra IA gerar HTML acidentalmente — não precisamos de DOMPurify.
 *  - Sem plugins remark/rehype adicionais (mantém comportamento previsível e
 *    bundle enxuto).
 *
 * Atenção (v10): o componente <ReactMarkdown> NÃO aceita mais prop `className`.
 * Para estilizar, wrap em <div className="...">...</div> no chamador.
 *
 * Uso:
 *   <div className="card card-success">
 *     <MarkdownText text={analise.causa_raiz} />
 *   </div>
 *
 * Fallback defensivo: retorna null se text for nullish/empty/whitespace-only —
 * evita renderizar <p></p> vazio que abre espaço supérfluo no PDF.
 */
// Override: react-markdown renderiza <p> por padrão. Quando MarkdownText
// é usado dentro de um <p> parent (acontece em vários campos do PDF e do
// modal v2), gera <p> aninhado em <p> — HTML inválido. Convertendo o
// renderer de "p" pra <span style="display:block"> mantém o comportamento
// visual de bloco mas usa elemento inline, válido em qualquer contexto.
const COMPONENTS = {
  p: ({ children }) => (
    <span style={{ display: 'block', marginBottom: '0.4em' }}>{children}</span>
  ),
};

export default function MarkdownText({ text }) {
  if (text == null) return null;
  const str = String(text);
  if (str.trim() === '') return null;
  return <ReactMarkdown components={COMPONENTS}>{str}</ReactMarkdown>;
}
